import { BaseModel } from "model/BaseModel";
import Deposito from "model/suprimentos/Deposito";

export default class OrigemProduto implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    depositoPadrao: Deposito | null;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        depositoPadrao = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.depositoPadrao = depositoPadrao;
    }
}